fourToldApp.controller('channelCntrl', function(xmppAuth, esb, $routeParams, services, $sce, $scope, $rootScope, $filter, $rootScope, $cookieStore, $localStorage, $mdDialog, $window, $mdToast, conversation_history, $interval, $location, storage, $locale, cryptool) {
    $scope.channel_name = "#" +$routeParams.alternateChannel;
    $scope.messages = [];
    var alternateChannelId = $routeParams.alternateChannelId;
    var alternateChannel = $routeParams.alternateChannel;
    var xmpp_domain =cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
    var xmppUser = $window.sessionStorage.getItem('userXmpp');
    var userData = services.user.getData();
    var interval;
    $scope.start = 0;
    $scope.dateMsg = undefined;
    $scope.metadataObj = undefined;
    $scope.imagen = "acount";
    $scope.typeSelect = undefined;
    $scope.simple = true;
    $scope.docFile = null;
    $scope.picFile = null;
    $scope.decimalSeparator =  $localStorage.decimalSeparator || ",";
    $scope.groupSeparator =  $localStorage.groupSeparator || '.';
    $scope.user = services.user.getPhoto();
    $scope.messagesAgaAction = [];
    $scope.showCancelLoan = userData.entity.status == 'OK'
    $window.sessionStorage.removeItem("viewTemplate");

    $localStorage.identification_channel = {
      "alternateChannelId": $routeParams.alternateChannelId,
      "alternateChannel" : $routeParams.alternateChannel
    }

    $scope.$on('$locationChangeStart', function(current, next, undefined) {
      $localStorage.identification_channel =  {
        "alternateChannelId": null,
        "alternateChannel" : null
      }
      //$window.localStorage.removeItem('metadataChannel');
    });

    $scope.$watch('DateInit', function (newval, oldval) {
      $scope.count = $scope.count + 1;
    });

    var channel //variable localStorage
    channel = $localStorage.channel.find( data => data.alternateChannelId === $routeParams.alternateChannelId)
    channel.unread = 0;
    $scope.renderHtml = function (htmlCode) {
      try{return $sce.trustAsHtml(htmlCode);}catch(error){}
    };

    if(channel.body){
      $scope.scrollBottom = "bottom";
      $scope.messages = channel.body;
      storage.setLocalStorages(channel.body[channel.body.length-1]);
      if($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined"){
        $scope.metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));
      }
    }
    else{
      services.conversation_history('bearer ' + $window.localStorage.getItem('access_token1')).request(
        {
            start: 0,
            maxRows: 60,
            channel: alternateChannelId
        },
        {},
        function (response) {
          $window.sessionStorage.setItem("conversationsCountChannel", response.conversationsCount);
          $window.sessionStorage.setItem('originalPageCountChannel', parseInt($window.sessionStorage.getItem('originalPageCountChannel') || 0) + response.conversations.length);
          conversation_history.setChatData(response, $scope.messages, 'login', null, channel);
          $scope.metadataObj = JSON.parse($window.localStorage.getItem('metadataObj'));
          $scope.scrollBottom = $scope.messages;
        });
    }


    $scope.$on('go', function () {
      var size =  parseInt($window.sessionStorage.getItem('originalPageCountChannel') || 0);
      var countRow = parseInt($window.sessionStorage.getItem('conversationsCountChannel')) - size;
      if($window.sessionStorage.getItem('conversationsCountChannel') !== '0' && countRow > 0){
          $rootScope.progressCircular = true;
          $scope.scrollBottom = undefined;
          var positionScroll = undefined;
          if(countRow > 60){
            countRow = 60;
            positionScroll = 59;
          } else positionScroll = countRow - 1;

          services.conversation_history('bearer ' + $window.localStorage.getItem('access_token1')).request({
            start: size,
            maxRows: countRow,
            channel: alternateChannelId
          }, {}, function(response) {
            $window.sessionStorage.setItem('originalPageCountChannel', parseInt($window.sessionStorage.getItem('originalPageCountChannel') || 0) + response.conversations.length);
            conversation_history.setChatData(response, $scope.messages, undefined, positionScroll);
          });
        }
    });

    function messageReceive(data){
        $scope.procesando = false;
        if(data.metadataObj){
            $scope.metadataObj = data.metadataObj;
            $scope.typeSelect = data.metadataObj;
            $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
            $localStorage.typeSelect = undefined;
        }else{
            $scope.metadataObj = undefined;
            $window.localStorage.setItem('metadataObj', undefined);
        }

        if(data.metadata && data.metadata.instruction && data.metadata.instruction.confirmation){
          $window.sessionStorage.setItem("confirmDialog", JSON.stringify(data.metadata.instruction));
        }
        else {
          $window.sessionStorage.removeItem("confirmDialog");
        }
        if(data.id)
          $window.sessionStorage.setItem('idAga', data.id);

        if(data.body && data.body.constraints && data.body.constraints.formBody)  {
          $window.sessionStorage.setItem("dataNotification", JSON.stringify(data));
        }
        else{
          $window.sessionStorage.removeItem("dataNotification");
        }

        $scope.disabledBtn = false;

        $scope.scrollBottom = $scope.messages;
        if(!$scope.messages.find(msg => msg.id === data.id) || data.type === 'sent' || data.type === 'RETRY') {
          $scope.messages.push(data);
          channel.body = $scope.messages; //variable localStorage
        }
    };


    $scope.menuItemClickListener = function(index)
    {
       $scope.sendMessageBasic("Cancelar crédito")
    }

     $scope.sendMessageBasic = function(msg)  { //message NLP
     if($window.localStorage.getItem('aga_status') && JSON.parse($window.localStorage.getItem('aga_status')).metadata.processControl.status === "PROCESSING"
      && msg.toUpperCase() !== "CANCELAR CRÉDITO"){
       var data = JSON.parse($window.localStorage.getItem('aga_status'));
       let msgTime = $localStorage.msg[$localStorage.msg.length-1].date;
       let timeObject = new Date(msgTime.getTime() + data.metadata.processControl.timeout * 1000);
       if(new Date() < timeObject){
         var processControlmessage = data.metadata.processControl.message || "Estamos procesando su respuesta, espere por favor...."
         showAlert(processControlmessage);
       } else{
         xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain, alternateChannelId, alternateChannel);
         $scope.newMessageInput = undefined;
       }
     }
     else{
         xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain, alternateChannelId, alternateChannel);
         $scope.newMessageInput = undefined;
     }
   }

     $scope.startInterval = function() {
       console.log("here interval");
       $scope.stop();
       interval = $interval(function(){
         $scope.safeApply($scope.checkAckFilter());
       }, 10000);
     };

     $scope.stop = function() {
       $interval.cancel(interval);
     };

     $scope.$on('$destroy', function() {
       $scope.stop();
     });

     $scope.$on("msgRecievedBroadcastChannel", function(event, data, type){
         switch(type) {
           case "ack":
             $scope.safeApply($scope.msgACK(data));
             break;
           case "composing":
            $scope.safeApply($scope.msgComposing());
             break;
          //case "FINISH":
          //  $scope.safeApply(messageReceive(data));
          //  break;  
           default:
             $scope.safeApply(messageReceive(data));
             if(interval.$$state.status === 2)
                 $scope.startInterval();
             break;
           }
     });

     $scope.$on("msgRecievedBroadcastHelp", function(event, data){
       console.log("Notifier ayuda...")
       $scope.helpTourFromNotifier(data)
     });

     $scope.checkAckFilter = function(){
       var filter = $filter('filter')($scope.messages, "check.png");
       if(filter.length > 0){
         var date = new Date();
         for(var i=0; i<filter.length; i++){
             var delayed = date - new Date(filter[i].date);
             if(filter[i].ack === false && delayed>20000){
                 filter[i].icon = "err_red.png";
                 filter[i].retry = true;
             }
           }
         }
     },

     $scope.checkAck = function(){
       const verification = $scope.messages.find( msg => msg.ack === false && msg.icon == "check.png");
       if(verification !== undefined){
         var date = new Date();
         for(var i=0; i<$scope.messages.length; i++){
             var delayed = date - $scope.messages[i].date;
             if($scope.messages[i].ack === false && delayed>20000){
                 $scope.messages[i].icon = "err_red.png";
                 $scope.messages[i].retry = true;
               }
             }
       } else $scope.stop();
     }

     $scope.msgACK = function(data){
       console.log(data);
       const resultado = $scope.messages.find( msg => msg.id === data );
       if(resultado !== undefined){
         resultado.icon = "checkblue.png";
         resultado.ack = true;
       }
     }

     $scope.msgComposing = function(){
       $scope.procesando = true;
     }

     $scope.safeApply = function(fn) {
         var phase = this.$root.$$phase;
         if(phase === '$apply' || phase === '$digest') {
             if(fn && (typeof(fn) === 'function')) {
                 fn();
             }
         } else {
             this.$apply(fn);
         }
     };

     $scope.questionsDialog = function(ev) {
       if($window.sessionStorage.getItem('needConfigureQuestions') === "true" && $window.localStorage.getItem('access_token1')){
         $scope.quentions = services.configuration_securityQuentions('bearer ' + $window.localStorage.getItem('access_token1')).getQuestions({}, {},  function(response) {
           if(response.code === 2 || response.data.length === 0){
             $window.sessionStorage.removeItem("needConfigureQuestions");
           } else {
             $mdDialog.show({
               locals:{dataToPass: response},
               templateUrl: 'views/dashboard/security_questions.html',
               parent: angular.element(document.body),
               targetEvent: ev,
               controller: 'quentionsCntrl',
               clickOutsideToClose:false
             });
           }
         });
       }
     }

     $scope.action = function(metadata, ev){
       switch (metadata.action) {
           case "newLoan":
               metadata.windowTitle = metadata.windowTitle || "Selecciona el crédito que deseas";
             if(metadata.lenderList.length > 0)
               $scope.entityLoans(ev);
             else showAlert("El sistema no puede asociar programas de créditos adecuado a tu perfil, uno de nuestros ejecutivos te estará contactando para validar tu información")
             break;
           case "signature":
             $scope.signature(ev);
             break;
           case "homeAddress":
               $scope.homeAddress(ev);
             break;
           case "requestSignature":
             $scope.requestSignature(ev);

             break;
           case "showGuarantorOffer":
             showGuarantorOffer(ev);
             break;
         }
         //showGuarantorOffer(ev);
     }

     $scope.showConfirm = function(ev) {
       $scope.disabledBtn = true;
       var confirmDialog = $scope.metadataObj.instruction;
       $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));

       var confirm = $mdDialog.show({
           controller: 'list',
           templateUrl: 'selectList.html',
           parent: angular.element(document.body),
           targetEvent: ev
       }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
       });
       if(ev){
         $scope.typeSelect = 1;
       }
     };


     $scope.entityLoans = function(ev) {
       var confirm = $mdDialog.show({
           controller: 'loanCntrl',
           templateUrl: 'loanList.html',
           parent: angular.element(document.body),
           targetEvent: ev
       }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
       });
       if(ev){
         $scope.typeSelect = 1;
       }
     };

     $scope.signature = function(ev) {
       var confirm = $mdDialog.show({
           controller: 'signatureCntrl',
           templateUrl: 'signature.html',
           parent: angular.element(document.body),
           targetEvent: ev,
           fullscreen: true,
       }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
       });
     };

     $scope.requestSignature = function(ev) {
       var confirm = $mdDialog.show({
           controller: 'signatureCntrl',
           templateUrl: 'signContract.html',
           parent: angular.element(document.body),
           targetEvent: ev,
           fullscreen: true,
       }).then(function() {
         }, function() {
             $scope.disabledBtn = false;
       });
     };

     function showGuarantorOffer(ev) {
       $mdDialog.show({
           controller: 'guarantorCntrl',
           templateUrl: './views/dashboard/guarantorOffer.html',
           parent: angular.element(document.body),
           targetEvent: ev,
           fullscreen: true,
       }).then(function() {
         }, function() {
             $scope.disabledBtn = false;
       });
     };

     $scope.homeAddress = function(ev) {
       var confirm = $mdDialog.show({
           controller: 'addressCntrl',
           templateUrl: 'address.html',
           parent: angular.element(document.body),
           targetEvent: ev,
           fullscreen: true,
       }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
         });
     };

     $scope.listCheckbox = function(ev) {
       var confirm = $mdDialog.show({
           controller: 'list',
           templateUrl: 'selectListMultiple.html',
           parent: angular.element(document.body),
           targetEvent: ev
       }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
       });
       if(ev){
         $scope.typeSelect = 1;
       }
     };

     $scope.msg_date_menu = function(fecha, msg, url, format){

       var dateMenu = undefined;
       var date = new Date();
       date = $filter('date')(date, "dd/MM/yyyy");
       var dateMsg =  $filter('date')(fecha, "dd/MM/yyyy");

       if(date === dateMsg)
         dateMenu = $filter('date')(fecha, "h:mm a");
       else dateMenu = dateMsg;

       if(url){
         if(format === 'jpg' || 'png' || 'image')
           $window.sessionStorage.setItem("msg","Imagen enviada");
         else
           $window.sessionStorage.setItem("msg","Documento enviado");
       }
       else
         $window.sessionStorage.setItem("msg",msg);

         $cookieStore.put('hora', dateMenu, {});
     };

     $scope.checkDate = function(date, index, messages){
       $scope.dateTest =  $filter('date')(messages[index].date, "dd/MM/yyyy");
       if(index>1){
         var dateGeneral = $filter('date')(messages[index-1].date, "dd/MM/yyyy");
       }
       return $scope.dateTest;
     };


     $scope.showDatePicker = function(ev) {
         $scope.disabledBtn = true;
         var confirm = $mdDialog.show({
             controller: 'date',
             controllerAs: 'ctrl',
             templateUrl: 'datePicker.html',
             parent: angular.element(document.body),
             targetEvent: ev
         }).then(function(answer) {
           console.log(answer);
           }, function() {
               $scope.disabledBtn = false;
           });
     };
     $scope.$watch("assignments", function (value) {//I change here

       $('#timepicker').mdtimepicker({format:'h:mm tt', hourPadding: true}, 'show');

     });
     $scope.sendTimeMsg = function() {
       xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain,  $scope.time,  $scope.time, "sent", "REPLY",  $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
       $scope.newMessageInput = undefined;
     };

     $scope.showTimePickerClick = function(ev) {
       $('#timepicker').mdtimepicker().on('timechanged', function(e){
         $scope.time = e.value.toLowerCase();
         console.log(e.value);
         console.log(e.time);
         $scope.sendTimeMsg();
       });
     };

     $scope.showTimePicker = function(ev) {
       $('#timepicker').mdtimepicker({format:'h:mm tt', hourPadding: true}, 'show');
       return $scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.constraints.type === 'Time';
     };

     $scope.helpTour = function(ev) {
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;
       var confirm = $mdDialog.show({
         locals:{dataToPass: null},
         controller: 'helpTourCntrl',
         templateUrl: './views/dashboard/helpTour.html',
         parent: angular.element(document.body),
         clickOutsideToClose: true,
         fullscreen: true,
         escapeToClose: true,
         targetEvent: ev
       }).then(function(answer) {
           $scope.modalCamera();
         }, function() {
           $scope.disabledBtn = false;
       });
     };

     $scope.helpTourFromNotifier = function(data) {

       var help = data.metadata.help;
       var confirm = $mdDialog.show({
         locals:{dataToPass: data},
         controller: 'helpTourCntrl',
         templateUrl: './views/dashboard/helpTour.html',
         parent: angular.element(document.body),
         clickOutsideToClose: true,
         fullscreen: true,
         escapeToClose: true,
       });
     };


     $scope.showImagePreview = function(ev) {
         if(ev.currentTarget.files !== undefined){
           //if(ev.currentTarget.files[0].type.includes($scope.metadataObj.constraints.format) === true){
           if(ev.currentTarget.files[0].type === 'image/jpeg' || ev.currentTarget.files[0].type === 'image/png'){
             $scope.disabledBtn = true;
             var confirm = $mdDialog.show({
               templateUrl: 'imagePreview.html',
               parent: angular.element(document.body),
               targetEvent: ev,
               locals: {dialogLocals:{picFile:ev.currentTarget.files[0]}},
               controller: 'image'
             }).then(function(answer) {}, function() {
               $scope.disabledBtn = false;
             });
           }
           else {
             $scope.docFile = undefined;
             $scope.progressCircular = undefined;
             $scope.msgToast("El archivo debe ser una imagen de tipo jpeg/png", "error-toast");
           }
         }
     };

     $scope.checkTypeFile = function(data){
       switch(data.constraints.format) {
           case "pdf":
             $scope.file = "application/pdf"
             break;
           case "image":
             $scope.file = "image/*"
             break;
         }
         return $scope.file;
     }

     $scope.uploadFiles = function(ev) {
       if(ev.currentTarget.files !== undefined){
           if(ev.currentTarget.files[0].type.includes($scope.metadataObj.constraints.format) === true){
             $scope.disabledBtn = true;
             var confirm = $mdDialog.confirm()
                   .textContent('Desea enviar archivo "'+ ev.currentTarget.files[0].name + '" ?')
                   .ariaLabel('enviar')
                   .targetEvent(ev)
                   .ok('Enviar')
                   .cancel('Cancelar');
             $mdDialog.show(confirm).then(function() {
               $scope.progressCircular = "ok";
               //$scope.showAlert()
               var payload = new FormData();
               //var format = ev.currentTarget.files[0].type.split("/");
               payload.append("file", ev.currentTarget.files[0]);
               payload.append('type', $scope.metadataObj.constraints.imageType);
               payload.append('latitude', "1");
               payload.append('longitude', "1");
               services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
                   //$scope.closeDialog();
                   $scope.progressCircular = undefined;
                   if(response.data.url){
                     var message = {text: ev.currentTarget.files[0].name, url: esb +"/security"+ response.data.url, type: "sent", layout: "end", format: $scope.metadataObj.constraints.format, typeDocument: "File"}
                     var value =  "{\"code\":\"1\",\"format\":\""+$scope.metadataObj.constraints.format+"\",\"imageCapture\":\"mandatory\",\"imageType\":\"externalPaymentReceipt\",\"type\":\"File\",\"url\":\""+esb +"/security"+ response.data.url+"\"}";
                     xmppAuth.Chat.sendMessageImage(xmppUser+"@"+xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value, alternateChannelId, alternateChannel);
                     $scope.metadataObj = undefined;
                   }
               });
             }, function(){$scope.docFile = undefined;});
           }
           else {
                 $scope.docFile = undefined;
                 $scope.progressCircular = undefined;
                 $scope.msgToast("El archivo debe ser un " + $scope.metadataObj.constraints.format, "error-toast");
         }
       }
     };

     var showAlert = function(message) {
       $mdDialog.show(
         $mdDialog.alert()
           .parent(angular.element(document.querySelector('#popupContainer')))
           .clickOutsideToClose(false)
           .textContent(message)
           .ok('Ok')
           .ariaLabel('Alert Dialog')
       ).then(function() {
         if(document.getElementById("inputSimple"))
           document.getElementById("inputSimple").focus();
       })
     };

     $scope.closeDialog = function(){
         $mdDialog.cancel();
     };

     $scope.cameraTour = function(ev) { 
      var confirm = $mdDialog.show({   
        locals: {
          isInit: false,
          isAudio: false,
          isVideo: true
         },    
        controller: 'cameraTourCntrl',
        templateUrl: './views/dashboard/cameraTour.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        escapeToClose: true,
        targetEvent: ev
      }).then(function(answer) {
          
        }, function() {
           
      });
    };
  
  
    function cameraPermission(ev, nextCall) {
      navigator.mediaDevices.getUserMedia({ audio: false, video:true }).then( ( stream ) => {
        stream.getTracks().forEach(track => {
          track.stop();
        }); 
          nextCall(ev)
      },
      e => {
        if(e.message == "Permission denied")
          $scope.cameraTour(ev, nextCall)
      })
    }
  
     $scope.modalCameraDialog = function(ev) {
         var confirm = $mdDialog.show({
           controller: 'camera',
           templateUrl: './views/dashboard/camera.html',
           parent: angular.element(document.body),
           targetEvent: ev
         }).then(function(answer) {
         }, function() {
             $scope.disabledBtn = false;
         });
    }

       
    $scope.modalCamera = function(ev) {
      cameraPermission(ev, $scope.modalCameraDialog)
    }
    
    $scope.clickUp = function() {
         setTimeout(function() {
           document.getElementById("file").click()
           $scope.disabledBtn = false;
         },0);
     };
     $scope.helpTourImage = function(ev) {
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;
       var confirm = $mdDialog.show({
         locals:{dataToPass: null},
         controller: 'helpTourCntrl',
         templateUrl: './views/dashboard/helpTour.html',
         parent: angular.element(document.body),
         clickOutsideToClose: true,
         escapeToClose: true,
         targetEvent: ev
       }).then(function(answer) {
           $scope.clickUp();
         }, function() {
           $scope.disabledBtn = false;
       });
     };

     $scope.showModalImage = function(ev) {
       $scope.disabledBtn = true;
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;

       if(help) {
         $scope.helpTourImage(ev)
       }
       else {
         $scope.clickUp();
       }
     };

     $scope.helpTourGallery = function(ev) {
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;
       var confirm = $mdDialog.show({
         locals:{dataToPass: null},
         controller: 'helpTourCntrl',
         templateUrl: './views/dashboard/helpTour.html',
         parent: angular.element(document.body),
         clickOutsideToClose: true,
         fullscreen: true,
         escapeToClose: true,
         targetEvent: ev
       }).then(function(answer) {
           $("#file").click();
         }, function() {
           $scope.disabledBtn = false;
       });
     };

     $scope.shouldShowHelp = function(){
      // $scope.disabledBtn = true;
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;

       if(help) {
         $scope.helpTourGallery()
       }
       else {
         $("#file").click();
       }
     }

     $scope.validateBarcode = function(ev, data){
       switch(data) {
         case "barcode":
               var confirm = $mdDialog.show({
                 controller: DialogController,
                 template: '<md-dialog class="dialogBarcode">' +
                           '  <h4 class="dialogTitleBarcode">Notificación</h4>'+
                           '  <md-dialog-content>'+
                                 '<div class="test"><p>Nuestro chat web no puede escanear tu código de barras en este momento, por favor toma una fotografía de la parte de atrás de tu cédula de ciudadanía con el código de barras.</p></div>'+
                           '  </md-dialog-content>' +
                           '    <md-dialog-actions layout="row">'+
                           '        <md-button class="md-primary" ng-click="answer(\'aceptar\')">'+
                           '          Aceptar'+
                           '        </md-button>'+
                           '    </md-dialog-actions>'+
                           '</md-dialog>',
                 parent: angular.element(document.body),
                 targetEvent: ev
               }).then(function(answer) {
                       console.log(answer);
                       if(answer === 'aceptar')
                         $scope.showModalCamera(ev);
               });
           break;
           default:
             $scope.showModalCamera(ev);
       }
     };

     function DialogController($scope, $mdDialog) {
         $scope.hide = function() {
           $mdDialog.hide();
         };

         $scope.cancel = function() {
           $mdDialog.cancel();
         };

         $scope.answer = function(answer) {
           $mdDialog.hide(answer);
         };
     };

     $scope.showModalCamera = function(ev) {
       $scope.disabledBtn = true;
       var messages =  $localStorage.msg;
       var lastMessage = messages[messages.length-1];
       var help = lastMessage.metadata.help;

       if(help) {
         $scope.helpTour(ev)
       }
       else {
         $scope.modalCamera();
       }
     };

     $scope.pendingSend = function(){};
     $scope.sendMsg = function() {
       document.getElementById("inputSimple").focus();
       if(document.getElementById("inputSimple").value.trim() !== ''){
         var msg = document.getElementById("inputSimple").value;
         if( $scope.metadataObj &&  $scope.metadataObj.instruction &&  $scope.metadataObj.instruction.confirmation) {
           $scope.pendingMessage = {};
           $scope.pendingMessage.id = msg;
           $scope.pendingMessage.value = msg;
           $scope.showConfirmation();
           $scope.pendingSend = function() {
             xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain,  $scope.pendingMessage.id,  $scope.pendingMessage.id, "sent", "BASIC", undefined, xmpp_domain, alternateChannelId, alternateChannel);
             $scope.newMessageInput = undefined;
             document.getElementById("inputSimple").value = '';
           }
         } 
         else if(channel.body[0].body.constraints.operation === "SUPPORTCHAT"){
            xmppAuth.Chat.sendMessagePeerToPeer(xmppUser+"@"+xmpp_domain, channel.body[0].fromJabberId, msg, "sent", "BASIC");
            $scope.newMessageInput = undefined;
            document.getElementById("inputSimple").value = '';
         }  
         else {
           $mdDialog.show({
            controller: DialogController,
            template: '<md-dialog class="dialogBarcode">' +
                      '  <h4 class="dialogTitleBarcode">Notificación</h4>'+
                      '  <md-dialog-content>'+
                            '<div class="test"><p>Mensaje no reconocido por el sistema</p></div>'+
                      '  </md-dialog-content>' +
                      '    <md-dialog-actions layout="row">'+
                      '        <md-button class="md-primary" ng-click="answer(\'aceptar\')">'+
                      '          OK'+
                      '        </md-button>'+
                      '    </md-dialog-actions>'+
                      '</md-dialog>',
            parent: angular.element(document.body)
          })
          $scope.newMessageInput = undefined;
          document.getElementById("inputSimple").value = '';
         }
       }
     };

     $scope.showConfirmation = function(ev) {
       var confirmDialog =  $scope.metadataObj.instruction;
       //var confirmDialog =  $scope.messages.body.metadata.instruction;
       confirmDialog.response = $scope.pendingMessage.value;
       $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));

       var confirm = $mdDialog.show({
           controller: 'confirmationCntrl',
           templateUrl: './views/dashboard/confirmation.html',
           parent: angular.element(document.body),
           targetEvent: ev
       }).then(function(answer) {
               $scope.pendingSend();
         }, function() {
       });

     };

     $scope.retrySendMessage = function(data) {
       xmppAuth.Chat.retrySendMessage(data, xmpp_domain);
     };

     $scope.sendMsgSelect = function(msg) {
        if( $scope.metadataObj &&  $scope.metadataObj.instruction &&  $scope.metadataObj.instruction.confirmation) {
           $scope.pendingMessage = msg;
           $scope.showConfirmation();
           $scope.pendingSend = function() {
             xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain,  $scope.pendingMessage.id,  $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
             $scope.metadataObj = undefined;
             $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
           }
         } else {
         xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg.id, msg.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
         $scope.metadataObj = undefined;
         $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
       }
     };

     $scope.retryMsg = function(msg) {
       var date = new Date();
       if($scope.lastActionMessageWasAnswered(msg))
         $window.sessionStorage.setItem('replyType', 'RETRY');
       else
         $window.sessionStorage.removeItem('replyType');

       message = {text: msg.text, date: date, metadataObj: msg.metadata, metadata: msg.metadata, id: msg.id, layout: "start", isAction: msg.isAction};
       $rootScope.$broadcast('msgRecievedBroadcastChannel', message);
     };

     $scope.skipMsg = function(){
       xmppAuth.Chat.sendSkipMsg(xmppUser+"@"+xmpp_domain, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
       $scope.metadataObj = undefined;
       $scope.newMessage = undefined;
     };

     $scope.sendMsgInputString = function(msg) {
       document.getElementById("stringInput").focus();
       if(msg === undefined || msg.trim() == "")
         $scope.msgToast("Debe enviar una respuesta", "error-toast");
       else {

         if( $scope.metadataObj &&  $scope.metadataObj.instruction &&  $scope.metadataObj.instruction.confirmation) {
           $scope.pendingMessage = {};
           $scope.pendingMessage.id = msg;
           $scope.pendingMessage.value = msg;
           $scope.showConfirmation();
           $scope.pendingSend = function() {
             xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain,  $scope.pendingMessage.id,  $scope.pendingMessage.id, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
             $scope.newMessage = undefined;
           }
         } else {
           xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg, msg, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
           $scope.newMessage = undefined;
         }
       }
     };

     $scope.sendMsgInputDouble = function(msg) {
       document.getElementById("doubleInput").focus();
       var max = $scope.metadataObj.constraints.max;
       var min = $scope.metadataObj.constraints.min;
       msg = msg.trim();
       if(msg === undefined || msg === null || msg === "")
           $scope.msgToast("Debe ingresar un valor menor o igual a "+ $scope.metadataObj.constraints.max, "error-toast");
       else {
         var w = $scope.cleanDouble(msg);
         var message = parseInt(w);
         var value = msg.toString();
         if( $scope.metadataObj.constraints.precision > 2) {
           message = parseFloat(w);
           value = w.toString();
         }

         if(message >  max && !(max == 0 && min == 0)) {
           $scope.msgToast("Debe ingresar un valor menor o igual a "+ max, "error-toast");
           return;
         }

         if(message < min && !(max == 0 && min == 0)) {
           $scope.msgToast("Debe ingresar un valor mayor o igual a "+ min, "error-toast");
           return;
         }
         if( $scope.metadataObj &&  $scope.metadataObj.instruction &&  $scope.metadataObj.instruction.confirmation) {
           $scope.pendingMessage = {};
           $scope.pendingMessage.id = msg;
           $scope.pendingMessage.value = msg;
           $scope.showConfirmation();
           $scope.pendingSend = function() {
             xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, message, value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
             $scope.newMessage = undefined;
           }
         } else {
           xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, message, value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, alternateChannelId, alternateChannel);
           $scope.newMessage = undefined;
         }

       }
     };

     $scope.format = function(num) {
       var decimalSeparator = $scope.decimalSeparator;
       var groupSeparator = $scope.groupSeparator;

       var floatSeparator = ".";
       var minus = false;
       if(num < 0) {
         minus = true;
         num = (-1)*num;
       }
       var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
       if(str.indexOf(floatSeparator) > 0) {
         parts = str.split(floatSeparator);
         str = parts[0];
       }
       str = str.split("").reverse();
       for(var j = 0, len = str.length; j < len; j++) {
         if(str[j] != groupSeparator) {
           output.push(str[j]);
           if(i%3 == 0 && j < (len - 1)) {
             output.push(groupSeparator);
           }
           i++;
         }
       }
       formatted = output.reverse().join("");
       result = formatted + ((parts) ? decimalSeparator + parts[1].substr(0, 2) : "");
       result = (minus ? "-" : "") + result;
       return(result);
     };

     $scope.cleanDouble = function(num) {
       var w = num.toString();
       var groupBlocks = w.split($scope.groupSeparator);
       for(var i = 0; i < groupBlocks.length; i++)
         w = w.replace($scope.groupSeparator, "");
       w = w.replace($scope.decimalSeparator, ".");
       return w;
     };

     $scope.formatDouble = function(e, sender) {
       var max = $scope.metadataObj.max;
       var min = $scope.metadataObj.min;
       var avoidFormatting = $scope.metadataObj.constraints.avoidFormatting;
       var decimalSeparator = $scope.decimalSeparator;
       var groupSeparator = $scope.groupSeparator;
       if(e.key == "-" &&  sender.newMessage.length == 1) {
         return;
       }
       if(e.key == "." || e.key == "," ) {
         sender.newMessage = sender.newMessage.replace(/.$/, decimalSeparator)
         return;
       }
       if(e.keyCode == 13 && sender.newMessage!==undefined) {
         $scope.sendMsgInputDouble(sender.newMessage)
       } else {
         /**/
         var oldval = sender.newMessage.substring(0, sender.newMessage.length - 1);
         if(sender.newMessage == "" | sender.newMessage == undefined) {
           document.getElementById("doubleInput").value = "";
           return;
         }
         var w = $scope.cleanDouble(sender.newMessage);
         var parsed = parseFloat(w)
         var numberVal = $scope.format(parsed);
         if(avoidFormatting) numberVal = w;
         if(isNaN(parsed)) numberVal = oldval;
         sender.newMessage =  numberVal;
       /**/
       }
     };

     var unbindWatcher = $scope.$watch(function () {
       if($window.localStorage.getItem("access_token1") === null){
         $scope.progressCircular = "ok";
         unbindWatcher();
       }
     });

     $scope.$watch(function() {
       if($localStorage.typeSelect){
           $scope.metadataObj = undefined;
       }
     });

     $scope.msgToast = function(message, type){
       $mdToast.show(
           $mdToast.simple()
           .textContent(message)
           .position('top')
           .action('Ok')
           .theme(type)
           .hideDelay(2000)
       );
     };

     $scope.lastActionMessageWasAnswered = function(message) {
       for (var i = $scope.messages.length - 1; i >= 0; i--) {
         var m = $scope.messages[i];
         var id = m.obj ? m.obj.body.id : m.id;
         if(message.id == id) {
           if(m.type == "sent")
             return true;
           else return false;
         }
       }
     }

     $scope.messageCanShow = function(index) {
       var lastActionIndex = -1;
       var message = $scope.messages[index];
       if(message.metadataObj.instruction.retryConstraint ==  "PREVIOUS_ONLY") {
         // revisamos si esta entre los ultimos mensaje de accion
         var actionMsgCount = 0;
         for (var i = $scope.messages.length - 1; i >= index; i--) {
           var local = $scope.messages[i];
           if(local.isAction) {
             actionMsgCount ++;
             if(lastActionIndex < 0) lastActionIndex = i;
             if(actionMsgCount > 2) return false;
             if(message.id == local.id && index != i) return false;
           }
         }
         var lastActionMessage = $scope.messages[lastActionIndex];
         if((actionMsgCount < 3) && lastActionMessage &&  (!$scope.lastActionMessageWasAnswered(lastActionMessage) || ($scope.lastActionMessageWasAnswered(lastActionMessage) && (lastActionMessage.id == message.id))))
           return true;
       } else return true;
     }

     $scope.openDynamicForm = function(ev) {
       if($window.sessionStorage.getItem("dataNotification")){
        $window.sessionStorage.setItem("viewTemplate", "channel/" + alternateChannel + "/" + alternateChannelId);
         $location.path("/viewform").search('alternateChannelId', alternateChannelId).search('alternateChannel', alternateChannel);//search(alternateChannelId=" + alternateChannelId + "&alternateChannel=" + alternateChannel);
       }
       else{
         showAlert("No existe información del formulario a mostrar");
       }
     };

     $scope.openLifeProofForm = function(ev) {
       if($window.sessionStorage.getItem("dataNotification")){
        $window.sessionStorage.setItem("viewTemplate", "channel/" + alternateChannel + "/" + alternateChannelId);
         $location.path("/viewform").search('alternateChannelId', alternateChannelId).search('alternateChannel', alternateChannel);//search(alternateChannelId=" + alternateChannelId + "&alternateChannel=" + alternateChannel);
       }
       else{
         showAlert("No existe información del formulario a mostrar");
       }
     };

     $scope.showDetailMessageInBlockSent = function(message) {
       var messageLocal = message.text; 
     
       if(message.type == 'sent' && message.body!=undefined &&  message.body.formatedMessageInBlock != undefined)
           messageLocal = message.body.formatedMessageInBlock;
     
       if(message.type == 'sent' && message.obj != undefined && message.obj.body != undefined && message.obj.body.formatedMessageInBlock != undefined)
           messageLocal = message.obj.body.formatedMessageInBlock;
       $mdDialog.show({
         
         template: '<md-dialog class="dialogBarcode">' +
         '  <h4 layout="row" layout-align="center center" class="dialogTitleBarcode"><strong>Información registrada</strong></h4>'+
         '  <md-dialog-content>'+
               '<div style="min-width: 300px; ">'+
               messageLocal+
               '</div>'+
         '  </md-dialog-content>' +
         '    <md-dialog-actions layout="row">'+
         '        <md-button class="md-primary" ng-click="answer(\'aceptar\')">'+
         '          Cerrar'+
         '        </md-button>'+
         '    </md-dialog-actions>'+
         '</md-dialog>',
         controller: DialogController,
         parent: angular.element(document.body),
         clickOutsideToClose: true,
         fullscreen: false,
         escapeToClose: true,
       });
     };
      $scope.$on('$locationChangeStart', function(current, next, undefined) {
        delete $routeParams.alternateChannelId;
        delete $routeParams.alternateChannel;
    });
    $scope.valueAssign = function(data){
      if(data.body){
        if(data.body.hasOwnProperty('formatedMessageInBlock'))
          return true;
      }
      if(data.obj && data.obj.body){
        if(data.obj.body.hasOwnProperty('formatedMessageInBlock'))
          return true;
      }
    };
 });